
import { Star, Quote } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";

interface TestimonialCardProps {
  text: string;
  author: string;
  location: string;
  avatarFallback: string;
  rating?: number;
  amount?: string;
}

const TestimonialCard = ({ 
  text, 
  author, 
  location, 
  avatarFallback,
  rating = 5,
  amount 
}: TestimonialCardProps) => {
  return (
    <Card className="bg-white hover:shadow-card-hover transition-shadow duration-300 border-slate-100 h-full flex flex-col">
      <CardContent className="p-6 flex flex-col h-full">
        {amount && (
          <div className="inline-flex items-center self-start px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-4">
            <span className="mr-1">Recovered:</span> {amount}
          </div>
        )}
        
        <div className="flex items-center gap-1 mb-4">
          {[1, 2, 3, 4, 5].map((star) => (
            <Star 
              key={star} 
              className={`h-4 w-4 ${star <= rating ? 'fill-yellow-400 text-yellow-400' : 'fill-slate-200 text-slate-200'}`} 
            />
          ))}
        </div>
        
        <div className="relative mb-6 flex-grow">
          <Quote className="absolute -top-2 -left-2 h-8 w-8 text-primary/10 rotate-180" />
          <p className="text-slate-700 relative z-10 pl-4">{text}</p>
        </div>
        
        <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-100">
          <Avatar className="border-2 border-white shadow-sm">
            <AvatarFallback className="bg-primary/10 text-primary">{avatarFallback}</AvatarFallback>
          </Avatar>
          <div>
            <p className="text-sm font-semibold text-slate-900">{author}</p>
            <p className="text-xs text-slate-500">{location}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
